export default class FileOperations {
  static urlToFile(url: string, filename: string): File {
    const arr = url.split(',');
    const match = arr[0].match(/:(.*?);/);

    if (!match) throw new Error('Failed to get file');

    const mime = match[1];
    const bstr = atob(arr[1]);
    let stringLength = bstr.length;
    const u8arr = new Uint8Array(stringLength);

    while (stringLength--) {
      u8arr[stringLength] = bstr.charCodeAt(stringLength);
    }

    const file = new File([u8arr], filename, { type: mime });
    if (!file) throw new Error('Failed to create file');

    return file;
  }

  static downloadFile(href: string, prefix: string) {
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    downloadLink.download = prefix;
    downloadLink.href = href;
    downloadLink.click();
  }
}
